import {useSuspenseQuery} from "@apollo/client";
import isEmpty from "lodash/isEmpty";
import {Link, useParams, useSearchParams} from "react-router";

import Button from "@/components/button/Button.tsx";
import {GetMaintenanceScheduleResult, GQL_MAINTENANCE_SCHEDULE_GET} from "@/lib/queries/maintenance.ts";
import {MaintenanceScheduleEditData} from "@/lib/types/maintenance.ts";
import {CreateEditMaintenanceScheduleForm} from "@/pages/maintenance/maintenance-create/CreateEditMaintenanceScheduleForm.tsx";
import {NotFoundPage} from "@/pages/website/NotFoundPage.tsx";

export const EditMaintenanceScheduleContent = () => {
  const {id} = useParams<{id: string}>();
  const scheduleId = parseInt(id || "0", 10);
  const [queryParams] = useSearchParams();

  const {data} = useSuspenseQuery<GetMaintenanceScheduleResult>(GQL_MAINTENANCE_SCHEDULE_GET, {
    variables: {id: scheduleId},
  });

  if (!data || isEmpty(data)) {
    return (
      <NotFoundPage
        title="Maintenace Not Found"
        message="The Maintenace you are looking for does not exist."
        redirectComponent={
          <Button as={Link} to="/maintenance">
            Go to Maintenance Page
          </Button>
        }
      />
    );
  }

  const maintenanceSchedule: MaintenanceScheduleEditData = {...data.maintenanceSchedule};

  if (queryParams.get("duplicate") === "true") {
    maintenanceSchedule.id = undefined;
    maintenanceSchedule.name = `${data.maintenanceSchedule.name} (Copy)`;
  }

  return <CreateEditMaintenanceScheduleForm schedule={maintenanceSchedule} />;
};
